import { Box, MenuItem, Stack, TextField } from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { getMinMachinesThunk } from "store/reducers/vending";

const VendingPanel = ({filter,setFilter}) => {
  useEffect(() => {
    dispatch(getMinMachinesThunk());
  }, []);

  const machines = useSelector((state) => state.vending.minMachines);
  return (
    <Box>
      <Stack direction="column" spacing={1.5}>
        <TextField
          label="Vending status"
          variant="outlined"
          select
          fullWidth
          value={filter.vend_status}
          onChange={(e) => setFilter({ ...filter, vend_status: e.target.value })}
          autoComplete="new-password"
          sx={{mb:2}}
        >
          <MenuItem value='success'>Success</MenuItem>
          <MenuItem value="failed">Failed</MenuItem>
          <MenuItem value="waiting">Waiting</MenuItem>
          
        </TextField>
        <AutoCompleteList
          items={machines}
          name="name"
          label="Select machine"
          setValue={(value) => {
            setFilter({
              ...filter,
              machine: value,
            });
          }}
          value={filter.machine}
        />
      </Stack>
    </Box>
  );
};

export default VendingPanel;
